import { useEffect, useRef, useState } from 'react';

export const useSummaryTimeline = (itemCount: number) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const iconRefs = useRef<(HTMLDivElement | null)[]>([]);

  const [activeStates, setActiveStates] = useState<boolean[]>(() => {
    return Array(itemCount).fill(false);
  });

  useEffect(() => {
    const container = sectionRef.current?.closest('[data-scroll-target="report-viewport"]') || window;

    const handleScroll = () => {
      if (!sectionRef.current) {
        return;
      }

      let viewportCenterY = 0;
      if (container instanceof HTMLElement) {
        const rect = container.getBoundingClientRect();
        viewportCenterY = rect.top + rect.height / 2;
      } else {
        viewportCenterY = window.innerHeight / 2;
      }

      const newActiveStates = Array(itemCount).fill(false);
      const iconCenters: number[] = [];

      // Calculate active state for each icon based on scroll position relative to viewport center
      for (let i = 0; i < itemCount; i++) {
        const iconEl = iconRefs.current[i];
        if (iconEl) {
          const rect = iconEl.getBoundingClientRect();
          const centerY = rect.top + rect.height / 2;
          iconCenters.push(centerY);

          if (centerY <= viewportCenterY) {
            newActiveStates[i] = true;
          }
        }
      }
      setActiveStates(newActiveStates);
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);

    const initialTimeout = setTimeout(() => {
      handleScroll();
    }, 100);

    return () => {
      container.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      clearTimeout(initialTimeout);
    };
  }, [itemCount]);

  return {
    sectionRef,
    iconRefs,
    activeStates,
  };
};
